import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// client js begin
import { env } from '@tencent/vft-common';
import expendServiceCoa from '@/services/expendService';
// client js end

import VImage from '@/components/base/VImage/VImage.vue';
import baseMixin from "../../baseMixin";

// 按顺序依次为会员中心、我的资产、礼品卡、邀请有礼
var jumpUrl = {
  'vip_member_center': 'tenvideo2://?action=20',
  'vip_property': '//film.qq.com/weixin/v3/asset/index.html?header=0&tab=award',
  'vip_customized_card': '//film.qq.com/weixin/h5/gift/?cardid=83231',
  'vip_invitation': '//film.qq.com/weixin/v3/invite-reward/index.html',
  'vip_check_in': '//film.qq.com/x/autovue/grade/?ptag=Vgrade.fls' // 本来是签到，临时改成跳转到等级体系
};

export default {
  props: ['data'],
  mixins: [baseMixin],
  data: function data() {
    return {
      redPointShow: true,
      // 红点文案
      redPointMsg: '新到账'
    };
  },
  computed: {
    // 是否是资产类型
    isVipPropertyType: function isVipPropertyType() {
      return this.data.sActID === 'vip_property';
    },
    // 是否是邀请有礼
    isVipInvitation: function isVipInvitation() {
      return this.data.sActID === 'vip_invitation';
    },
    now: function now() {
      return this.$store.state.nowTimestamp;
    },
    // 赢千元文案
    invitationMsg: function invitationMsg() {
      if (this.now >= 1545321600 && this.now < 1545580800) {
        // 12月21日0时0分0秒至12月23日最后一秒
        return '限时5折';
      } else {
        return '赢千元';
      }
    },
    hasRedPoint: function hasRedPoint() {
      if (this.data.sActID !== 'vip_property') return false;
      return this.$store.state.showRedPoint;
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!env.isApp) {
                jumpUrl['vip_member_center'] = '//film.qq.com/h5/vip-center/index.html';
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  components: {
    VImage: VImage
  },
  methods: {
    jump: function jump() {
      var sActID = this.data.sActID;
      if (jumpUrl[sActID]) {
        if (this.isVipPropertyType) {
          this.clearRedPoint();
          this.redPointShow = false;
        }
        this.openUrl(jumpUrl[sActID]);
      } else if (sActID === 'vip_link') {
        this.openUrl(this.data.tActType.sH5Url);
      }
    },
    clearRedPoint: function () {
      var _clearRedPoint = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return expendServiceCoa();
              case 3:
                _context2.next = 7;
                break;
              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));
      function clearRedPoint() {
        return _clearRedPoint.apply(this, arguments);
      }
      return clearRedPoint;
    }()
  },
  reportData: {
    '固定入口按钮': function 固定入口按钮(title) {
      return {
        f_resource: title,
        f_type: 4,
        eid: 'fuli_button',
        rtype: 'h5',
        f_module: '固定入口'
      };
    }
  }
};